<template>
  <slot v-if="shouldDisplay()"></slot>
</template>

<script>
export default {
  name: "IsAdmin",
  data() {
    return {
      roles: [
        'Admin',
      ]
    }
  },
  methods: {
    shouldDisplay() {
      return this.roles.includes(this.userRole)
    }
  },
  computed: {
    userRole() {
      return this.$store.getters.getGravyUserRole
    }
  }
}
</script>

<style scoped>

</style>